<div *ngIf="flightConfigurationDto" class="img-box">
    <img src="/assets/images/drone/{{flightConfigurationDto.name}}.png">
</div>

<div class="choice-box">
    <div class="sbox">
        <select (change)="selectManufacturer($event)">
            <option *ngFor="let manufacturer of manufacturerList;" [value]="manufacturer" [selected]="manufacturer === flightConfigurationDto.manufacturer">
                {{ manufacturer }}
            </option>
        </select>
    </div>
    <div class="sbox">
        <select (change)="selectDrone($event)">
            <option *ngFor="let droneSpec of droneSpecList; let i = index;" [value]="i" [selected]="droneSpec.seq === flightConfigurationDto.droneSpecSeq">
                {{ droneSpec.name }}
            </option>
        </select>
    </div>
</div>